export const MESSAGE_FIELDS_ES = {
    txtClaveDosUsuario:'Contraseña',
    txtClaveUsuario:'Contraseña',
    txtFechaDesdeEmb: 'Fecha desde',
    txtFechaHastaEmb: 'Fecha hasta'
}
